import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'gulli_cookie_consent';

export type ConsentStatus = 'accepted' | 'rejected' | null;

@Injectable({
  providedIn: 'root'
})
export class ConsentService {
  private readonly consent$ = new BehaviorSubject<ConsentStatus>(this.readFromStorage());

  constructor() {}

  /**
   * Returns true if user accepted, false if rejected, null if not yet decided.
   */
  hasConsent(): boolean | null {
    const status = this.consent$.getValue();
    if (status === null) return null;
    return status === 'accepted';
  }

  /**
   * Returns true if user has made a choice (accepted or rejected).
   */
  hasDecided(): boolean {
    return this.consent$.getValue() !== null;
  }

  /**
   * Observable of consent status for reactive updates.
   */
  get consentStatus$() {
    return this.consent$.asObservable();
  }

  accept(): void {
    this.save('accepted');
  }

  reject(): void {
    this.save('rejected');
  }

  private readFromStorage(): ConsentStatus {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'accepted' || raw === 'rejected') return raw;
    return null;
  }

  private save(status: 'accepted' | 'rejected'): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, status);
    }
    this.consent$.next(status);
  }
}
